export class BackendHTTPError extends Error {
  statusCode: number
  statusText: string
  constructor(errorMessage: string, statusCode: number, statusText: string) {
    super(errorMessage)
    this.statusCode = statusCode
    this.statusText = statusText
  }
}
